import React, {useEffect, useState} from "react";
import {useMsal} from "@azure/msal-react";
import {Box, Button, useTheme, Typography} from "@mui/material";
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import {loginRequest} from '../../config.js';
import CustomModal from "../components/ui/custom-modal.component.jsx";
import UserProfileDialog from "../../plugins/ProfilePlugin/components/user/user-profile.dialog.jsx";
import {useSnackbar} from 'notistack';
import {useRBAC, useRBACStore} from '../../plugins/RBACPlugin/index.js';
import LoginBanner from "../../assets/images/login-banner.png";
import CustomTypography from "../components/ui/CustomTypography.jsx";
import SBMALogo from "../../assets/icons/sbma-logo.png";
import { useNavigate } from "react-router-dom";
import { get } from "lodash";
import useUserProfile from "../../plugins/ProfilePlugin/hooks/useUserProfile.js";
import AdminProfileService from "../../plugins/ProfilePlugin/services/api/index.js";


const LoginScreen = () => {
  const theme = useTheme();
  const navigate = useNavigate()

  const profile_uid = localStorage.getItem("profile_uid");

  const [openModal, setOpenModal] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");

  const {setCurrentProfile} = useRBACStore();
  const {getProfilePermissions, profilePermissions, isDoneGetProfilePermissions, errorGetProfilePermissions} = useRBAC();

  const {getProfile, profileTypeList, loading} = useUserProfile();
  const [isLogin, setIsLogin] = useState(false);
    
  const {instance} = useMsal();
  const {enqueueSnackbar} = useSnackbar();
  const [profileType, setProfileType] = useState();
  const [profileData, setProfileData] = useState(null);
  const handleCloseModal = () => setOpenModal(false);

  const handleSelectProfile = (profile) => {
    setSelectedProfile(profile)
    localStorage.setItem("profile_uid", profile.profile_uid);
    getProfilePermissions(profile.profile_uid);
  }
  

  const login = async () => {
    try {
      const response = await instance.loginPopup(loginRequest);

      if (response) {
        getProfile();
        setIsLogin(true);
      } 
    } catch (error) {
      console.log("Login error:", error);
    }
  };


  useEffect(() => {
    if(profileTypeList)
    setProfileType(profileTypeList[0]);
    setProfileData(profileTypeList);
  },[profileTypeList])


  console.log("Profile Type:", profileType);
  console.log("profile data", profileData);

  useEffect(() => {
    if(isLogin) {
      if ( profileData.length > 1) {
        setOpenModal(true);
      } else if (profileData.length === 1) {
          setSelectedProfile(profileType)
          localStorage.setItem("profile_uid", profileType.profile_uid);
          // get new profile permissions
          getProfilePermissions(profileType.profile_uid);
      }

    }
  }, [profileType, profileData, isLogin]);


  useEffect(() => {
      if (selectedProfile && isDoneGetProfilePermissions && profilePermissions.length > 0) {
          setCurrentProfile({
              profileId: selectedProfile.profile_uid,
              profileType: selectedProfile.profile_type,
              permissions: profilePermissions,
              orgId: selectedProfile.org_uid,
              role: selectedProfile.role,
          }).then(() => {
              window.location.href = "/dashboard";
          })
      }
  }, [JSON.stringify(selectedProfile), JSON.stringify(profilePermissions), isDoneGetProfilePermissions])

  useEffect(() => {
    if (errorGetProfilePermissions) {
      let err_msg = errorGetProfilePermissions?.error || errorGetProfilePermissions?.message || "Something went wrong.";
      
      enqueueSnackbar(err_msg, {
        variant: "error",
        autoHideDuration: 3000
      });
    }
  }, [JSON.stringify(errorGetProfilePermissions)])


  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: {xs: 'column', md: 'row'},
        height: {xs: 'auto', md: '100vh'},
      }}
    >
      <Box
        sx={{
          flex: {xs: 'none', md: 1.4},
          width: {xs: '100%', md: 'auto'},
          height: {xs: '50vh', md: 'auto'},
          position: 'relative',
          backgroundImage: `url(${LoginBanner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: {xs: 'center', md: 'flex-start'},
          p: {xs: 3, sm: 4, md: 8},
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundColor: "#00255c",
            zIndex: 1,
            opacity: 0.45
          }}
        />

        <Box sx={{position: 'relative', zIndex: 2, textAlign: {xs: 'center', md: 'left'}, maxWidth: {xs: '90%', md: '100%'}}}>
          <CustomTypography
            variant="h2"
            text={"Streamline your entry management"}
            customStyles={{
              marginBottom: 1,
              color: "#fff",
              fontWeight: 700,
              marginTop: {xs: 0, md: -8},
              fontSize: {xs: 20, sm: '2.5rem', md: 60},
              letterSpacing: 1.5
            }}
          />

          <CustomTypography
            variant="subtitle1"
            text={"Secure, efficient gate pass management for businesses, drivers, and visitors."}
            customStyles={{
              color: "#fff",
              fontSize: { xs: 16, sm: 20, md: 22 }
            }}
          />

          <Box mt={3} display="flex" gap={1} flexDirection={{xs: "column", sm: "row"}} alignItems={{xs: "center", sm: "flex-start"}}>
            <Button
              disableRipple
              variant="contained"
              startIcon={<LockIcon />}
              sx={{
                backgroundColor: "#64748B",
                textTransform: "none",
                fontWeight: 400,
                width: {xs: "auto !important"}
              }}
            >
              Secure access control
            </Button>

            <Button
              disableRipple
              variant="contained"
              startIcon={<EmailIcon />}
              sx={{
                backgroundColor: "#4B5563",
                textTransform: "none",
                fontWeight: 400,
                width: {xs: "auto !important"}
              }}
            >
              Real-time notifications
            </Button>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          flex: {xs: 'none', md: 0.8},
          width: {xs: '100%', md: 'auto'},
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          height: {xs: "50vh", sm: "50vh", md: "auto"},
          background: 'linear-gradient(to bottom, #f4faff, #dceefd)',
          p: {xs: 3, md: 4},
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: 1,
            textAlign: 'center',
            mt: -4
          }}
        >
          <img alt="" src={SBMALogo} style={{height: 64, width: 64, marginBottom: "5px"}} />

          <Typography variant="h4" fontWeight="bold" gutterBottom>
            SBMA WEB PORTAL
          </Typography>

          <Typography variant="body1" fontSize={18} mb={3}>
            Manage your gate pass requests, bookings,<br />
            and visitor entries efficiently
          </Typography>

          <Button
            variant="contained"
            size="large"
            startIcon={<LockIcon />}
            sx={{
              bgcolor: '#0090dd',
              px: 5,
              py: 1,
              fontSize: 18,
              textTransform: "none",
              mb: 4,
              '&:hover': {
                bgcolor: '#0077be',
              },
            }}
            onClick={login}
          >
            Sign In
          </Button>

          <Typography variant="body2" color="text.secondary">
            Need help?{" "}Contact administrator
          </Typography>
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{mt: 2, mb: -3}}>
          © 2025. Subic Bay Metropolitan Authority
        </Typography>
      </Box>

      <CustomModal 
        open={openModal} 
        title="Select Profile"
        handleClose={handleCloseModal} 
      >
        <UserProfileDialog handleSelectProfile={handleSelectProfile} loading={loading} profileTypeList={profileTypeList} />
      </CustomModal>
    </Box>
  )
}

export default LoginScreen
